// MOMERY CUSTOM: Habitat 14 compatible product quantity validation.
(function (root) {
  'use strict';

  const QUANTITY_SELECTOR =
    'form[action*="/cart/add"] input.qty[type="number"][name="quantity"]';

  function integer(value) {
    const parsed = Number.parseInt(value, 10);
    return Number.isNaN(parsed) ? null : parsed;
  }

  function minimumOf(input) {
    return integer(input?.getAttribute?.('min')) ?? 1;
  }

  function maximumOf(input) {
    const dataMaximum = integer(input?.dataset?.max);
    if (dataMaximum !== null) return dataMaximum;

    const nativeMaximum = integer(input?.getAttribute?.('max'));
    return nativeMaximum ?? Infinity;
  }

  function clampValue(input, value) {
    const minimum = minimumOf(input);
    const maximum = maximumOf(input);
    const parsed = integer(value);
    return Math.min(Math.max(parsed ?? minimum, minimum), maximum);
  }

  function validationMessage(input, value) {
    const parsed = integer(value);
    const minimum = minimumOf(input);
    const maximum = maximumOf(input);

    if (parsed === null) return 'Bitte eine Zahl eingeben.';
    if (parsed < minimum) return `Mindestens ${minimum} Stück.`;
    if (parsed > maximum) return `Nur bis ${maximum} Stück möglich.`;
    return '';
  }

  function syncNativeMaximum(input) {
    const dataMaximum = integer(input?.dataset?.max);
    if (dataMaximum !== null) input.setAttribute('max', String(dataMaximum));
  }

  function syncQuantityInputs(scope) {
    const queryRoot = scope?.querySelectorAll ? scope : root.document;
    queryRoot?.querySelectorAll?.(QUANTITY_SELECTOR).forEach(syncNativeMaximum);
  }

  const api = {
    clampValue,
    maximumOf,
    minimumOf,
    syncNativeMaximum,
    syncQuantityInputs,
    validationMessage,
  };

  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.MomeryProductQuantityGuard = api;

  const document = root.document;
  if (!document || root.__momeryProductQuantityGuard) return;
  root.__momeryProductQuantityGuard = true;

  function quantityInputFromEvent(event) {
    const target = event.target;
    return target?.matches?.(QUANTITY_SELECTOR) ? target : null;
  }

  document.addEventListener(
    'input',
    (event) => {
      const input = quantityInputFromEvent(event);
      if (!input) return;

      const digits = input.value.replace(/\D/g, '');
      if (digits !== input.value) input.value = digits;
      const message = digits ? validationMessage(input, digits) : '';
      input.setCustomValidity(message);
      if (message) input.reportValidity();
    },
    true
  );

  // Habitat 14 keeps ownership of quantity-selector and receives the normalized event.
  document.addEventListener(
    'change',
    (event) => {
      const input = quantityInputFromEvent(event);
      if (!input) return;

      syncNativeMaximum(input);
      input.value = String(clampValue(input, input.value));
      input.setCustomValidity('');
    },
    true
  );

  document.addEventListener(
    'keydown',
    (event) => {
      const input = quantityInputFromEvent(event);
      if (input && event.key === 'Enter') {
        event.preventDefault();
        input.blur();
      }
    },
    true
  );

  syncQuantityInputs(document);
  document.addEventListener('shopify:section:load', (event) => syncQuantityInputs(event.target));
})(typeof window !== 'undefined' ? window : globalThis);
